import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useTheme } from '@mui/material/styles';
import { Grid2, Box } from '@mui/material';
import { useTranslations } from 'next-intl';
import 'swiper/css';
import 'swiper/css/grid';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './index.css';
import { Autoplay, Grid, Pagination, Navigation } from 'swiper/modules';
import useMediaQuery from '@mui/material/useMediaQuery';
import SwiperText from './SwiperText';

const slidesList = [
  {
    title: `Akra's global hiring strategy: hiring niche talent beyond borders using Sailglobal`,
    desciption: 'Jeremy C.',
    backgroundColor: '#DBEAFE',
  },
  {
    title:
      "Aspire's APAC expansion: a record-breaking success story with Sailglobal",
    desciption: 'Katie R.',
    backgroundColor: '#FFE2D7',
  },
  {
    title:
      'Achieving global compliance: Sailglobal helps Axero Solutions save $1M annually while ensuring ...',
    desciption: 'Thomas.',
    backgroundColor: '#E1FFE9',
  },
  {
    title:
      "From 0 to 100 in 10 months: Sailglobal's role in DB Results' rapid scaling success in the Philippines...",
    desciption: 'Jeremy C.',
    backgroundColor: '#FFDAF4',
  },
  {
    title:
      'Sailglobal in HR: Vast network, pro team, tech-savvy, global expertise.',
    desciption: 'Tobby Logan.',
    backgroundColor: '#FFFCF1',
  },
  {
    title:
      'Sailglobal in HR: Customized HR strategies, fit for every biz need.',
    desciption: 'Chen Huang.',
    backgroundColor: '#CCFBF1',
  },
];

const MessageSwiper: FC = () => {
  const t = useTranslations('Home');
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box
      py={{
        xs: 2,
        md: 4,
      }}
    >
      <Grid2 container size={12} data-aos="fade-down" justifyContent={'center'}>
        <Box
          sx={{
            fontWeight: 700,
            color: '#000',
            fontSize: {
              xs: '32px',
              md: '40px',
            },
          }}
        >
          {t('messageTitle')}
        </Box>
      </Grid2>
      <Grid2
        size={12}
        container
        sx={{ pt: 4 }}
        data-aos={isMd ? 'zoom-in' : 'fade-up'}
        data-aos-duration={600}
      >
        <Swiper
          initialSlide={0}
          direction="horizontal"
          slidesPerView={isMd ? 4 : 1}
          spaceBetween={20}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          grabCursor={true}
          pagination={false}
          navigation={false}
          grid={{
            rows: 1,
          }}
          modules={[Autoplay, Grid, Pagination, Navigation]}
          className="mySwiper"
        >
          {slidesList.map((item, index) => (
            <SwiperSlide key={`${item.backgroundColor}_${index}`}>
              <Box
                sx={{
                  height: {
                    xs: '160px',
                    md: '200px',
                  },
                }}
              >
                <SwiperText
                  title={item.title}
                  desciption={item.desciption}
                  boxSx={{
                    backgroundColor: item.backgroundColor,
                    color: '#000',
                    height: {
                      xs: '160px',
                      md: '200px',
                    },
                  }}
                  desciptionSx={{
                    color: '#333',
                    pt: 3,
                    fontSize: {
                      xs: '16px',
                      md: '20px',
                    },
                  }}
                  titleSx={{
                    width: 'inherit',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'horizontal',
                    fontSize: {
                      xs: '16px',
                      md: '20px',
                    },
                  }}
                />
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Grid2>
    </Box>
  );
};

export default MessageSwiper;
